import { createRouter } from "vue-router";

import LoginView from "@/views/LoginView.vue";
import RegistrationView from "@/views/RegistrationView.vue";
import ConfirmationView from "@/views/ConfirmationView.vue";
import ResetPasswordView from "@/views/ResetPasswordView.vue";

import ChangePasswordView from "@/views/user/ChangePasswordView.vue";

import DayView from "@/views/client/DayView.vue";
import NotesView from "@/views/client/NotesView.vue";
import IdeasView from "@/views/client/IdeasView.vue";
import SettingsView from "@/views/client/SettingsView.vue";
import GroupsView from "@/views/client/GroupsView.vue";
import GroupInfoView from "@/views/client/GroupInfoView.vue";

import MainAdminView from "@/views/admin/MainAdminView.vue";
import UsersAdminView from "@/views/admin/UsersAdminView.vue";
import GroupsAdminView from "@/views/admin/GroupsAdminView.vue";
import GroupsAndUsersAdminView from "@/views/admin/GroupsAndUsersAdminView.vue";
import InvitationsAdminView from "@/views/admin/InvitationsAdminView.vue";
import AuthorsAdminView from "@/views/admin/AuthorsAdminView.vue";
import CitationsAdminView from "@/views/admin/CitationsAdminView.vue";
import HobbiesAdminView from "@/views/admin/HobbiesAdminView.vue";
import SportsAdminView from "@/views/admin/SportsAdminView.vue";
import FoodAdminView from "@/views/admin/FoodAdminView.vue";
import DessertsAdminView from "@/views/admin/DessertsAdminView.vue";

const routes = [
    {
        path: "/login",
        name: "loginPage",
        component: LoginView,
        meta: {
            pageTitle: "Вход",
            role: null
        }
    },
    {
        path: "/registration",
        name: "registrationPage",
        component: RegistrationView,
        meta: {
            pageTitle: "Регистрация",
            role: null
        }
    },
    {
        path: "/confirmation",
        name: "confirmationPage",
        component: ConfirmationView,
        meta: {
            pageTitle: "Подтверждение пароля",
            role: null
        }
    },
    {
        path: "/resetPassword",
        name: "resetPasswordPage",
        component: ResetPasswordView,
        meta: {
            pageTitle: "Восстановление пароля",
            role: null
        }
    },

    {
        path: "/",
        name: "/"
    },

    {
        path: "/changePassword",
        name: "changePasswordPage",
        component: ChangePasswordView,
        meta: {
            pageTitle: "Изменение пароля",
            role: null
        }
    },
    {
        path: "/groups",
        name: "groupsPage",
        component: GroupsView,
        meta: {
            pageTitle: "Группы",
            role: null
        }
    },
    {
        path: "/group/:groupGuid",
        name: "groupInfoPage",
        component: GroupInfoView,
        meta: {
            pageTitle: "Группа",
            role: null
        },
        props: route => ({
            groupGuid: String(route.params.groupGuid)
        })
    },

    {
        path: "/day",
        name: "dayPage",
        component: DayView,
        meta: {
            pageTitle: "День",
            role: "Client"
        }
    },
    {
        path: "/notes",
        name: "notesPage",
        component: NotesView,
        meta: {
            pageTitle: "Заметки",
            role: "Client"
        }
    },
    {
        path: "/ideas",
        name: "ideasPage",
        component: IdeasView,
        meta: {
            pageTitle: "Идеи",
            role: "Client"
        }
    },
    {
        path: "/settings",
        name: "settingsPage",
        component: SettingsView,
        meta: {
            pageTitle: "Настройки",
            role: "Client"
        }
    },

    {
        path: "/admin/main",
        name: "mainAdminPage",
        component: MainAdminView,
        meta: {
            pageTitle: "Главная (админка)",
            role: "Administrator"
        }
    },
    {
        path: "/admin/users",
        name: "usersAdminPage",
        component: UsersAdminView,
        meta: {
            pageTitle: "Пользователи (админка)",
            role: "Administrator"
        }
    },
    {
        path: "/admin/groups",
        name: "groupsAdminPage",
        component: GroupsAdminView,
        meta: {
            pageTitle: "Группы (админка)",
            role: "Administrator"
        }
    },
    {
        path: "/admin/groupsAndUsers",
        name: "groupsAndUsersAdminPage",
        component: GroupsAndUsersAdminView,
        meta: {
            pageTitle: "Члены групп (админка)",
            role: "Administrator"
        }
    },
    {
        path: "/admin/invitations",
        name: "invitationsAdminPage",
        component: InvitationsAdminView,
        meta: {
            pageTitle: "Приглашения (админка)",
            role: "Administrator"
        }
    },
    {
        path: "/admin/authors",
        name: "authorsAdminPage",
        component: AuthorsAdminView,
        meta: {
            pageTitle: "Авторы (админка)",
            role: "Administrator"
        }
    },
    {
        path: "/admin/citations",
        name: "citationsAdminPage",
        component: CitationsAdminView,
        meta: {
            pageTitle: "Цитаты (админка)",
            role: "Administrator"
        }
    },
    {
        path: "/admin/hobbies",
        name: "hobbiesAdminPage",
        component: HobbiesAdminView,
        meta: {
            pageTitle: "Хобби (админка)",
            role: "Administrator"
        }
    },
    {
        path: "/admin/sports",
        name: "sportsAdminPage",
        component: SportsAdminView,
        meta: {
            pageTitle: "Спорт (админка)",
            role: "Administrator"
        }
    },
    {
        path: "/admin/food",
        name: "foodAdminPage",
        component: FoodAdminView,
        meta: {
            pageTitle: "Блюда (админка)",
            role: "Administrator"
        }
    },
    {
        path: "/admin/desserts",
        name: "dessertsAdminPage",
        component: DessertsAdminView,
        meta: {
            pageTitle: "Десерты (админка)",
            role: "Administrator"
        }
    }
];

export default function (history, store) {
    const router = createRouter({
        history,
        routes
    });

    router.beforeEach((to, from, next) => {
        if (to.path === "/") {
            if (store.state.isClient) {
                next("/day");
            } else if (store.state.isAdministrator) {
                next("/admin/main");
            } else {
                next("/login");
            }
        } else if ((store.state.isClient || store.state.isAdministrator)
            && (to.path === "/login" || to.path === "/registration")) {
            next("/");
        } else if (!to.name && !from.name) {
            next("/");
        } else if (!to.name) {
            next(false);
        } else if (to.meta.role && !store.state.userRoles.includes(to.meta.role)) {
            next("/");
        } else {
            if (to.meta?.pageTitle) {
                document.title = to.meta.pageTitle;
            }

            next();
        }
    });

    return router;
}
